import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Card, Header } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Components
import CurrentMyTimesheetIsEditable from 'components/CurrentMyTimesheetIsEditable';
// @ts-ignore
import Offline from 'components/Offline';
// @ts-ignore
import Online from 'components/Online';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

// Local Components
import MyTimesheetEntriesCardContent from './components/MyTimesheetEntriesCardContent';
import MyTimesheetEntriesDailyTotalCard from './components/MyTimesheetEntriesDailyTotalCard';

// Local Selectors
// @ts-ignore
import { selectMyTimesheetEntriesArrayUuids } from './selectors';

interface ConnectedProps {
    uuids?: string[];
    startDate: string;
}

type Props = ConnectedProps;

export class MyTimesheetEntriesCard extends React.PureComponent<Props> {
    renderEntries(): React.ReactElement {
        const { uuids = [], startDate } = this.props;

        return (
            <React.Fragment>
                <Card fluid>
                    {uuids.map((uuid, index) => (
                        <MyTimesheetEntriesCardContent
                            index={index}
                            key={uuid}
                            myTimesheetEntryUuid={uuid}
                            myTimesheetStartDate={startDate}
                        />
                    ))}
                </Card>
                <MyTimesheetEntriesDailyTotalCard />
            </React.Fragment>
        );
    }

    render(): React.ReactElement {
        const { uuids } = this.props;

        if (!uuids || !uuids.length) {
            return (
                <Header as="h3" textAlign="center">
                    <Header.Subheader>
                        <CurrentMyTimesheetIsEditable
                            FallbackComponent={
                                <React.Fragment>
                                    <Offline>
                                        Go online to view this timesheet.
                                    </Offline>
                                    <Online>
                                        {
                                            "This timesheet can't be edited." /* eslint-disable react/jsx-curly-brace-presence */
                                        }
                                    </Online>
                                </React.Fragment>
                            }
                        >
                            <React.Fragment>
                                No current entries. Press the ‘Create Entry’
                                button create a new entry.
                            </React.Fragment>
                        </CurrentMyTimesheetIsEditable>
                    </Header.Subheader>
                </Header>
            );
        }

        return (
            <CurrentMyTimesheetIsEditable
                FallbackComponent={
                    <React.Fragment>
                        <Offline>
                            <Header as="h3" textAlign="center">
                                <Header.Subheader>
                                    Go online to view this timesheet.
                                </Header.Subheader>
                            </Header>
                        </Offline>
                        <Online>{this.renderEntries()}</Online>
                    </React.Fragment>
                }
            >
                {this.renderEntries()}
            </CurrentMyTimesheetIsEditable>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    uuids: selectMyTimesheetEntriesArrayUuids,
    startDate: makeSelectQueryStringValue('date')
});

export default connect(mapStateToProps)(MyTimesheetEntriesCard);
